import * as React from "react";
import { IconProps } from "./IconProps";

export const IconSortDescending = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.0016 4C6.55388 4 7.0016 4.44772 7.0016 5V16.5849L8.2927 15.2931C8.68313 14.9025 9.31629 14.9023 9.70692 15.2927C10.0975 15.6831 10.0977 16.3163 9.7073 16.7069L6.70889 19.7069C6.52141 19.8945 6.26708 19.9999 6.00187 20C5.73665 20.0001 5.48227 19.8948 5.29468 19.7073L2.29308 16.7073C1.90245 16.3169 1.90228 15.6837 2.2927 15.2931C2.68313 14.9025 3.31629 14.9023 3.70692 15.2927L5.0016 16.5867V5C5.0016 4.44772 5.44931 4 6.0016 4ZM11 7C11 6.44772 11.4477 6 12 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H12C11.4477 8 11 7.55228 11 7ZM13 12C13 11.4477 13.4477 11 14 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H14C13.4477 13 13 12.5523 13 12ZM15 17C15 16.4477 15.4477 16 16 16H20C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H16C15.4477 18 15 17.5523 15 17Z"
          fill={color}
        />
      </svg>
    );
  },
);
